export default __webpack_public_path__ + "static/media/imovelSmall.56d6d87f.png";